import { makeAutoObservable } from "mobx";

const MAX_RECALLS = 20;
const MAX_RETAINS = 50;

export class MemoryStore {
  reflect = null;
  recalls = [];
  retains = [];
  bankIdPrefix = null;
  itemCount = 0;
  lastEventAt = null;

  constructor() {
    makeAutoObservable(this);
  }

  setReflect(data) {
    this.reflect = { ...data, ts: Date.now() };
    this.lastEventAt = Date.now();
  }

  addRecall(data) {
    this.recalls = [{ ...data, ts: Date.now() }, ...this.recalls].slice(0, MAX_RECALLS);
    this.lastEventAt = Date.now();
  }

  addRetain(data) {
    this.retains = [{ ...data, ts: Date.now() }, ...this.retains].slice(0, MAX_RETAINS);
    this.lastEventAt = Date.now();
    this.itemCount += (data.items || []).length;
  }

  setBankIdPrefix(prefix) {
    this.bankIdPrefix = prefix;
  }

  clear() {
    this.reflect = null;
    this.recalls = [];
    this.retains = [];
    this.itemCount = 0;
    this.lastEventAt = null;
  }
}

export const memoryStore = new MemoryStore();
